<template>
  <div class="accounts-container">
      <div class="account-head flex-between">
        <div class="account-head-l flex-row-start">
          <img src="../../assets/images/coin.png" alt="" class="coin-img">
          <div class="coin-text">
            <div class="fs-16">星币</div>
            <div class="coin-num">{{userMoney.xing_chen_bi}}</div>
          </div>
        </div>
        <div class="account-head-r column">
          <div class="milestone">
            <div class="milestone-item fs-16"><i class="el-icon-trophy"></i> 我的里程碑</div>
          </div>
          <div class="milestone-list flex-row">
            <div class="m-item" v-for="item in levelList" :key="item.id">
              <img :src="item.image"  class="m-item-img" :class="{img_opacity : item.status}">
            </div>
          </div>
        </div>
      </div>
      <div class="account-title">收支明细</div>
      <template>
        <el-table
          :data="list"
          style="width: 100%"
          height="290">
          <el-table-column
            prop="msg"
            label="事项"
            >
          </el-table-column>
          <el-table-column
  
            label="收入（个）"
            width="180">
            <template slot-scope="scope">
              <span  :class="{type_2: scope.row.types === 2}">{{scope.row.income}}</span>
            </template>
            
          </el-table-column>
          <el-table-column

            label="支出（个）">
            <template slot-scope="scope">
              <span :class="{type_1: scope.row.types === 1}">{{scope.row.spending}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="时间"
            width="180"
            >
          </el-table-column>
        </el-table>
        <div class="clearfix list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.pageSize"
            :total="pageTotal"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </template>
  </div>
</template>

<script>
export default {
  name: "accounts",
  data() {
    return {
      query:{
        page:1,
        pageSize: 10
      },
      list:[],
      userMoney: {},
      pageTotal: 0,
      levelList: [
        {id: 1,image: require('../../assets/images/1_6/lv1.png'),status: true},
        {id: 2,image: require('../../assets/images/1_6/lv2.png'),status: false},
        {id: 3,image: require('../../assets/images/1_6/lv3.png'),status: false},
        {id: 4,image: require('../../assets/images/1_6/lv4.png'),status: false},
        {id: 5,image: require('../../assets/images/1_6/lv5.png'),status: false},
        {id: 6,image: require('../../assets/images/1_6/lv6.png'),status: false},
      ]
    }
  },
  created() {
    
    this.getUserMoney();
    this.getUserRunningList();
  },
  methods: {
    getUserMoney() {
      this.getRequest("/wenjiaoopne/kc/user/userMoney")
        .then((result) => {
          this.userMoney = result.data;
          
        })
        .catch(() => {});
    },
    getUserRunningList(){
        this.getRequest("/wenjiaoopne/kc/user/userRunningList",this.query)
        .then((result) => {
          this.list = result.data.list;
          this.pageTotal = result.data.total_count;
        })
        .catch(() => {});
    },
     handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getUserRunningList();
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
}
</script>

<style scoped>
.accounts-container{
  padding: 20px 30px;
}
.accounts-container .coin-img{
  width: 56px;
  height: 87px;
}
.account-head-l{
  width: 35%;
  height: 90px;
  border-right: 1px dashed #ccc;
}
.account-head-l .coin-text{
  padding-left: 15px;
}

.account-head-l .coin-num{
  padding-top: 5px;
  font-size:30px;
}
.account-head-r{
  width: 60%;
}

.account-head-r .milestone{
  position: relative;
  width: 225px;
  border-top: 1px dashed #ccc;
}
.milestone-item{
  position: absolute;
  top: -12px;
  left: 58px;
  padding: 0 5px;
  background-color: #fff;
}
.milestone-list .m-item-img{
  width: 100%;
  height: 100%;
  opacity: .3;
}

.milestone-list .img_opacity{
  opacity: 1!important;
}
.milestone-list{
  padding: 30px 0;
}
.milestone-list .m-item{
  width: 78px;
  height: 78px;
  border-radius: 50%;
  margin: 0 4px;

}
.account-title{
  padding: 10px 0;
  font-size:18px;
}
.accounts-container .type_1{
  color: #bc4654;
}
.accounts-container .type_2{
  color: #5C954B;
}
.list-page{
  padding-top: 5px;
  text-align: right;
}
</style>